import React from "react";
import "./OpenPositions.css";

export default function OpenPositions({ currentLanguage = "en" }) {
  const isFrench = currentLanguage === "fr";

  // ================= ENGLISH DATA =================
  const dataEN = {
    title: "OPEN POSITIONS",
    subtitle: "Find your next career opportunity with us",
    jobs: [
      {
        title: "Senior Financial Analyst",
        location: "Jaipur, Rajasthan",
        experience: "5+ years experience",
        type: "Full-time",
        desc:
          "Lead financial analysis and strategic planning initiatives for our Fortune 500 clients. Requires 5+ years of experience in financial consulting.",
      },
      {
        title: "Tax Consultant",
        location: "Jaipur, Rajasthan",
        experience: "4+ years experience",
        type: "Full-time",
        desc:
          "Provide comprehensive tax advisory services to corporate clients. CPA certification required with 3+ years of tax consulting experience.",
      },
      {
        title: "Junior Auditor",
        location: "Jaipur, Rajasthan",
        experience: "1+ years experience",
        type: "Full-time",
        desc:
          "Join our audit team to conduct financial statement audits and compliance reviews. Ideal entry-level position for recent graduates.",
      },
      {
        title: "Management Consultant",
        location: "Jaipur, Rajasthan",
        experience: "2+ years experience",
        type: "Full-time",
        desc:
          "Drive operational improvements and strategic initiatives for mid-market companies. MBA preferred.",
      },
      {
        title: "Business Consultant",
        location: "Jaipur, Rajasthan",
        experience: "3+ years experience",
        type: "Full-time",
        desc:
          "Deliver strategic recommendations to help clients achieve sustainable growth.",
      },
    ],
  };

  // ================= FRENCH DATA =================
  const dataFR = {
    title: "POSTES OUVERTS",
    subtitle: "Trouvez votre prochaine opportunité de carrière avec nous",
    jobs: [
      {
        title: "Analyste financier senior",
        location: "Jaipur, Rajasthan",
        experience: "5+ ans d’expérience",
        type: "Temps plein",
        desc:
          "Piloter les analyses financières et les initiatives de planification stratégique pour nos clients internationaux.",
      },
      {
        title: "Consultant fiscal",
        location: "Jaipur, Rajasthan",
        experience: "4+ ans d’expérience",
        type: "Temps plein",
        desc:
          "Fournir des services de conseil fiscal complets aux entreprises clientes. Certification professionnelle requise.",
      },
      {
        title: "Auditeur junior",
        location: "Jaipur, Rajasthan",
        experience: "1+ an d’expérience",
        type: "Temps plein",
        desc:
          "Participer aux missions d’audit financier et de conformité. Poste idéal pour les jeunes diplômés.",
      },
      {
        title: "Consultant en management",
        location: "Jaipur, Rajasthan",
        experience: "2+ ans d’expérience",
        type: "Temps plein",
        desc:
          "Conduire des améliorations opérationnelles et des projets stratégiques pour des entreprises de taille intermédiaire.",
      },
      {
        title: "Consultant en stratégie",
        location: "Jaipur, Rajasthan",
        experience: "3+ ans d’expérience",
        type: "Temps plein",
        desc:
          "Formuler des recommandations stratégiques pour aider les clients à atteindre leurs objectifs de croissance.",
      },
    ],
  };

  // ================= SELECT LANGUAGE =================
  const data = isFrench ? dataFR : dataEN;
  const { title, subtitle, jobs } = data;

  return (
    <div className="openpositionBox">
      <div className="container openpositions-wrapper">
        {/* Heading */}
        <h2 className="openpositions-title">{title}</h2>
        <p className="openpositions-subtitle">{subtitle}</p>

        {/* Job Cards */}
        <div className="row mt-4">
          {jobs.map((job, idx) => (
            <div
              className="col-lg-4 col-md-6 col-sm-12 mb-4 padding-mobile"
              key={idx}
            >
              <div className="job-card">
                <div className="d-flex justify-content-between">
                  <h4 className="job-title">{job.title}</h4>
                  <span className="exp-badge">{job.experience}</span>
                </div>

                <p className="job-location">
                  <img
                    src="/assets/images/Career/location.png"
                    alt="location"
                    className="location-icon"
                  />
                  {job.location}
                </p>

                <p className="job-desc">{job.desc}</p>

                <div className="d-flex justify-content-between align-items-center mt-3">
                  <span className="job-type-badge">{job.type}</span>

                  <button className="apply-btn">
                    {isFrench ? "Postuler" : "Apply Now"}{" "}
                    <img
                      src="/assets/images/Career/arrowwhite.png"
                      alt=""
                      width={15}
                    />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
